"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pull = pull;
exports.ResultProvider = void 0;

var _util = require("../util");

var _AnnotationsProvider = require("../../annotations/AnnotationsProvider");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ResultProvider =
/*#__PURE__*/
function () {
  function ResultProvider(dataService) {
    _classCallCheck(this, ResultProvider);

    // NOTE THIS TRICKERY! IA Results are embedded in the Annotations API, so we build these methods on top of the
    // annotations API! This design means that if you want both annotations and results you'll be making duplicate HTTP
    // requests. TODO: Request cleaner APIs (or design this one to leverage some kind of cache?)
    this._annotationsProvider = new _AnnotationsProvider.AnnotationsProvider(dataService);
  }

  _createClass(ResultProvider, [{
    key: "list",
    value: function () {
      var _list = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(imageId, macroId) {
        var response, outputLayer, inputLayer;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._annotationsProvider.list(imageId);

              case 2:
                response = _context.sent;
                outputLayer = (0, _util.findTheOneTrueOutputLayer)(macroId, response.data);

                if (outputLayer) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", null);

              case 6:
                inputLayer = response.data.find(function (l) {
                  return l.id === outputLayer.inputAnnotationId;
                });
                return _context.abrupt("return", createIaResults(outputLayer, inputLayer));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function list(_x, _x2) {
        return _list.apply(this, arguments);
      };
    }()
  }]);

  return ResultProvider;
}();

exports.ResultProvider = ResultProvider;

function createIaResults(outputLayer, inputLayer) {
  var out = {};
  out.macroId = outputLayer.macroId;
  var rawData = out.data = {};
  var regions = out.regions = {};

  var pendingRegions = out.pendingRegions = _toConsumableArray(inputLayer.regions);

  var metaData = out.metaData = {};
  outputLayer.attributes && outputLayer.attributes.forEach(function (attribute) {
    rawData[attribute.name] = rawData[attribute.name] || {};
    rawData[attribute.name].slide = attribute.value;
    metaData[attribute.name] = attribute;
  });
  outputLayer.regions && outputLayer.regions.forEach(function (region) {
    // copy region data for now;
    regions[region.id] = region;
    region.attributes && region.attributes.forEach(function (attribute) {
      rawData[attribute.headerName] = rawData[attribute.headerName] || {};
      rawData[attribute.headerName][region.id] = attribute.value;
    }); // Remove any analyzed regions from the "pending" list

    pull(pendingRegions, inputLayer.regions.find(function (r) {
      return r.id === region.inputRegionId;
    }));
  });
  return out;
} // TODO: move to utils?


function pull(array, value) {
  var ix = array.indexOf(value);

  if (ix > -1) {
    array.splice(ix, 1);
  }

  return array;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/image-analysis/result-data/ResultProvider.js
// module id = 231
// module chunks = 0